import { FunctionalComponent, h } from 'preact';

import { Gallery2ImageTemplate } from 'common/module/gallery-2-image/template';
import { ImageGalleryItemTemplatePropsInterface } from 'common/module/image-gallery/item-template-props.interface';

/**
 * Template for Gallery Scroll image gallery item
 */
export const GalleryScrollItemTemplate: FunctionalComponent<
  ImageGalleryItemTemplatePropsInterface & {
    classname?: string;
  }
> = (props): preact.JSX.Element => (
  <Gallery2ImageTemplate
    key={props.key}
    src={props.item.sourceUrl}
    webp={props.webp}
    style={props.style}
    classname={props.classname}
    alt={props.alt}
    title={props.title}
    placeholder={props.placeholder}
  />
);
